import { Box } from '@mui/material';
import { ErrorCircleIcon } from '@synergy/theme-next';
import { ReactNode } from 'react';
import { makeStyles } from '@mui/styles';

import { PoolTab, PoolTabProps } from '../tab/pool-tab';

const useStyles = makeStyles(() => ({
    tab: {
        display: 'flex',
        gap: '8px',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));

export interface DirtyTabOwnProps {
    label: ReactNode;
    isValid: boolean;
}

export type DirtyTabProps = DirtyTabOwnProps & PoolTabProps;

export const DirtyTab = (props: DirtyTabProps) => {
    const classes = useStyles();
    const { label, isValid, ...rest } = props;

    return (
        <PoolTab
            label={
                <div className={classes.tab}>
                    {(!isValid && <ErrorCircleIcon fontSize="small" />) || undefined}
                    <Box sx={{ color: theme => (!isValid ? theme.palette.error.main : undefined) }}>{label}</Box>
                </div>
            }
            {...rest}
        />
    );
};
